import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";

export function useContentSecurityControls() {
    let cipherText = [];
    let floatingText = [];

    const selectedLanguage = useSelector(currentSelectedLanguage);
    

    const tabMap = {
        'Personal': 'personalTab',
        'Company': 'companyTab',
        'Admin': 'AdminTab'
    };

    
    const lookupData = useSelector((state) => state.settings.lookupData);

    function getContentSecurityControlData(settings) {
        const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
        let cipherTextControls = [];
        let floatingTextControls = [];
        let disableControl=false;
        const createSettingControlObject = (id, type, label, level, controlType = "Radio", options = [], placeholder = "", showTooltip, tooltip,className="") => {
            let setting = level.find((setting) => setting.type.trim() === type.trim());
            let value = setting?.keyValue || "";
            let containerClassname = "mb-3 row align-items-center mx-1"
            let isOverride=setting?.isOverride;
            let isLock=setting?.isLock;
            if (className !== "") {
                containerClassname += ` ${className}`;
            }

            if(type=== "CipherPattern" && value !== "2") {
               disableControl = true;

            }
            if(type=== "Shape" && disableControl) {
               isOverride="false";
               isLock="false";
            }



            return {
                id: String(id),
                label: selectedLanguage.LstLanguageCodes[`UI_${label}`],
                controlType,
                containerClassname,
                value: (disableControl && type === "Shape") ? 0 : value,
                isShowLockIconOnDisable: isLock === "false" || isLock === "" ? false : true,
                settingType: type,
                level: level === cipherText ? 'cipherText' : "floatingText",
                options: options,
                Override: isOverride || "",
                Lock: isLock || "",
                settingId: settings[tabKey]?.settingsData[0]?.id,
                placeholder: placeholder,
                configLevel: settings[tabKey]?.settingsData[0]?.configLevel,
                isShowToolTip: showTooltip,
                tooltip: tooltip,
                showHistory: true,
                ...((disableControl && type === "Shape") ? { disableCipherShape : true,Override: isOverride || "",Lock: isLock || "" } : {})

            };
        };
        if (settings[tabKey]?.selectedTab === "ContentSecurity") {
            cipherText = [...settings[tabKey]?.settingsData[0]?.cipherText || []];
            floatingText = [...settings[tabKey]?.settingsData[0]?.floatingText || []];
       
            cipherTextControls = [
                createSettingControlObject("1", "CipherText", "CipherText", cipherText, "Dropdown", lookupData.cipherTextOptions),
                createSettingControlObject("2", "Opacity", "Opacity", cipherText, "Dropdown", lookupData.opacityOptions),
                createSettingControlObject("3", "CipherView", "CipherView", cipherText, "Dropdown", lookupData.cipherViewOptions),
                createSettingControlObject("4", "CipherPattern", "CipherPattern", cipherText, "Dropdown", lookupData.cipherPatternOptions),
                createSettingControlObject("5", "Shape", "Shape", cipherText, "Dropdown", lookupData.shapeOptions,"",false,"","pb-3"),
            ];


            floatingTextControls = [
                createSettingControlObject("1", "FloatingText", "FloatingText", floatingText, "Dropdown", lookupData.floatingTextOptions),
                createSettingControlObject("2", "SuffixPrefixFloatingText", "SuffixPrefixFloatingText", floatingText, "custom-Textbox-Dropdown", lookupData.suffixPrefixOptions,selectedLanguage.LstLanguageCodes.UI_EnterText),
                createSettingControlObject("3", "Opacity", "Opacity", floatingText, "Dropdown", lookupData.opacityOptions),
                createSettingControlObject("4", "Navigation", "Navigation", floatingText, "Dropdown", lookupData.navigationOptions),
                createSettingControlObject("5", "FontColor", "FontColor", floatingText, "Dropdown", lookupData.fontColorOptions),
                createSettingControlObject("6", "FontSize", "FontSize", floatingText, "Dropdown", lookupData.fontSizeOptions),
                createSettingControlObject("7", "Speed", "Speed", floatingText, "Dropdown", lookupData.speedOptions,"", false, "", "pb-3"),
            ];
        }
        return [cipherTextControls, floatingTextControls];
    }
    return {
        getContentSecurityControlData
    }
}
